import { styled as muiStyled } from '@mui/material';


export const M3Body = muiStyled('span')`
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; 
    letter-spacing: 0.1px;
`;
export const M3BodyMedium = muiStyled('span')`
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
  `;
  
export const M3BodySmall = muiStyled('div')`
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
  `;

  
export const M3LabelMedium = muiStyled('div')`
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: ${props => props.theme.palette.text.secondary};
`;
export const M3LabelSmall = muiStyled('div')`
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
`;

export const M3LabelLarge = muiStyled('span')`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
`;


export const M3BodyLarge = muiStyled('div')`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: ${props => props.theme.palette.text.main};
`;

export const M3TitleSmall = muiStyled('div')`
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const M3TitleMedium = muiStyled('div')`
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const M3TitleLarge = muiStyled('div')(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '26px',
  fontStyle: 'normal',
  fontWeight: 'bold',
  lineHeight: '28px',
  letterSpacing: '0.5px',
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '24px',
  },
}));

export const M3HeadlineSmall = muiStyled('div')(({ theme }) => ({
  fontFamily: 'Inter',
  fontSize: '24px',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '32px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '20px',
    lineHeight: '26px',
  },
}));